var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLine',{attrs:{"id":"chart","chart-options":_vm.options,"chart-data":_vm.chartData,"width":100,"height":50}})
}
var staticRenderFns = []

export { render, staticRenderFns }